export class Debouncer<K, T> {
  private timeoutId: number | null = null;
  private readonly delay: number;
  private cancelReject: ((error: Error) => void) | null = null;

  constructor(delay: number = 300) {
    if (delay < 0) {
      throw new Error('Delay must be a non-negative number');
    }
    this.delay = delay;
  }

  debounce(
    target: (args: K) => Promise<T>,
    args: K
  ): Promise<T> {
    this.cancelPending();  // Clear any existing timeout

    return new Promise((resolve, reject) => {
      this.timeoutId = window.setTimeout(() => {
        this.timeoutId = null;
        target(args)
          .then(resolve)
          .catch(reject);
      }, this.delay);

      // Store reject to call it on cancellation
      this.cancelReject = reject;
    });
  }

  cancelPending(): void {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
      if (this.cancelReject) {
        this.cancelReject(new Error("Debounced operation canceled"));
        this.cancelReject = null;
      }
    }
  }
}